import React, { Component } from "react";
import logo from "../logo.svg";
import { Link, animateScroll as scroll } from "react-scroll";
import { ACCESS_TOKEN_NAME } from '../constants/apiContants';
import './Navbar.css';
import store from "../store/index";
import i18n from '../i18n';
export default class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: localStorage.getItem('lang')?localStorage.getItem('lang'):'ar',
    };
    //this.changeLanguage = this.changeLanguage.bind(this)
  }
  scrollToTop = () => {
    scroll.scrollToTop();
  };

  render() {

    let self =this;
    store.subscribe(() =>
    { console.log('change lang'+store.getState().lang);
    localStorage.setItem('lang', store.getState().lang)

    self.setState({lang:localStorage.getItem('lang')});
    });
    return (
      <div>
      <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-xs-12" style={{maxHeight:'30%'}}>
            <div className="widget clearfix hidemob">
              <img src="https://www.mosa.gov.om/images/logo1.png" alt="" />

              {/* <div className="widget-title">
                <h3>About US</h3>
              </div>
              <p> The Sultan Qaboos Stadium at the Sultan Qaboos Sports Complex (Arabic: مجمع السلطان قابوس الرياضي‎) also known locally as Boshar (Arabic: بوشر‎), is a government-owned multi-purpose stadium in the Boshar district of Muscat, Oman. It is currently used mostly for football matches, and also has facilities for athletics.</p>   
                           */}
            </div>{/* end clearfix */}
          </div>{/* end col */}
          
          <div className="col-lg-8 col-md-8 col-xs-12">
            <div className="widget clearfix" style={{marginTop:'5%'}}>
              <div className="widget-title">
                <h3  style={{ fontFamily: 'Tajawal' }}>{ i18n.t('JK82',  this.state.lang) }</h3>
              </div>
              <ul className="footer-links">
                <li><a href="mailto:#">admin@mosa.gov.om</a></li>
                <li><a href="https://www.mosa.gov.om/">mosa.gov.om</a></li>
                <li>Building# 1407, 3318 3318 Way, Muscat 112</li>
                <li>24 755260</li>
              </ul>{/* end links */}
            </div>{/* end clearfix */}
          </div>{/* end col */}
        </div>{/* end row */}
      </div>{/* end container */}
    </footer>{/* end footer */}
    <div className="copyrights">
      <div className="container">
        <div className="footer-distributed">
          <div className="footer-center">                   
            <p className="footer-company-name"><span className="m_1"  style={{ fontFamily: 'Tajawal' }}>جميع الحقوق محفوظة لوزارة الثقافة والرياضة والشباب
</span></p>
          </div>
        </div>
      </div>{/* end container */}
    </div>
</div>
    );
  }
}
